import React from 'react'
import { Navigation } from '@griegconnect/krakentools-react-kraken-app'
import { withActiveTenant } from '@app/routes/WithActiveTenant'
import { withServices } from '@app/routes/withServices'
import { PATH_TENANT_BASE, Permissions, PERMISSIONS } from '@app/constants'
import { AccessDependencies } from '@app/Content'
import { requireAllGlobalPermissions } from '@app/lib/access'

const PATH = PATH_TENANT_BASE + '/admin/bewator'

const bewatorActive = (d: AccessDependencies) => d.portConfig.bewator

export const bewatorModuleNavs: Navigation.Item<AccessDependencies>[] = [
  {
    name: 'Bewator',
    path: PATH + '/',
    page: React.createElement(withServices(withActiveTenant(React.lazy(() => import('./index'))))),
    exact: true,
    menu: true,
    access: (d) =>
      bewatorActive(d) && requireAllGlobalPermissions(Permissions.all(PERMISSIONS.global_access_system))(d),
  },
]
